import * as OSS from 'ali-oss';
import { RcFile } from 'antd/lib/upload';
import * as CryptoJS from 'crypto-js';

import { config } from '../config';

export enum FileMimeType {
  JPG = 'image/jpg',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
}

const FILE_MIME_TYPE_EXTENSION = {
  [FileMimeType.JPEG]: 'jpeg',
  [FileMimeType.JPG]: 'jpg',
  [FileMimeType.PNG]: 'png',
};

export interface File {
  url: string;
  fileSize: number;
  mimeType: string;
  fileName: string;
  group: string;
  createAt: Date;
}

class FileManager {
  ossClient: OSS;
  constructor() {
    this.ossClient = new OSS({
      accessKeyId: config.ALIYUN_OSS_ACCESS_KEY_ID,
      accessKeySecret: config.ALIYUN_OSS_ACCESS_KEY_SECRET,
      region: config.ALIYUN_OSS_REGION,
      bucket: config.ALIYUN_OSS_BUKECT,
    });
  }

  public uploadPath = (fileName: unknown) => {
    // 上传文件的路径,upload为中转文件夹，先上传到upload文件夹下，然后再copy 到指定目录中
    return `upload/${fileName}`;
  };

  private async getFileHash(file: Blob) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.addEventListener('load', () => {
        const wordArray = CryptoJS.lib.WordArray.create(fileReader.result);

        const hash = CryptoJS.SHA1(wordArray).toString();

        resolve(hash);
      });

      fileReader.addEventListener('error', e => {
        reject(e);
      });

      fileReader.readAsArrayBuffer(file);
    });
  }

  public uploadToOss = async (file: RcFile) => {
    const fileName = await this.getFileHash(file);
    const extension = FILE_MIME_TYPE_EXTENSION[file.type];
    const url = `${this.uploadPath(fileName)}.${extension}`;

    return new Promise((resolve, reject) => {
      this.ossClient
        .put(url, file)
        .then(data => {
          resolve({ ...data, fileNameWithExt: `${fileName}.${extension}` });
        })
        .catch(error => {
          reject(error);
        });
    });
  };
}

export const fileManager = new FileManager();



// WEBPACK FOOTER //
// ./src/services/file.ts